import React from "react";
import { ShieldAlert, Shield } from "lucide-react";
import { Badge } from "@/components/Badges";

// Staff role chips shown next to a forum author's name. Uses the same compact chip geometry as the
// site badge component. Admin = red (matches the admin-mode chip), Moderator = teal.
const ROLE_CHIP = {
  super_admin: { label: "Admin", bg: "#A33D28", Icon: ShieldAlert },
  admin: { label: "Admin", bg: "#A33D28", Icon: ShieldAlert },
  moderator: { label: "Mod", bg: "#2f6f5f", Icon: Shield },
};

// Account badges ported into the forum: staff role + Ambassador + Founding Member, rendered in the
// exact site badge style (compact). Nothing renders when the author carries none of these.
export function ForumAuthorBadges({ role, badges, accountType, className = "" }) {
  const rc = ROLE_CHIP[role];
  const list = badges || [];
  if (!rc && list.length === 0) return null;
  const tone = accountType === "business" ? "blue" : "green";
  const RIcon = rc?.Icon;
  return (
    <span className={`flex flex-wrap items-center gap-1.5 ${className}`} data-testid="forum-author-badges">
      {rc && (
        <span
          data-testid={`forum-author-role-${role}`}
          className="inline-flex items-center gap-1 border border-transparent font-mono uppercase tracking-[1.2px] leading-none px-2 py-[3px] text-[9px]"
          style={{ backgroundColor: rc.bg, color: "#fff" }}
        >
          <RIcon className="w-2.5 h-2.5 shrink-0" strokeWidth={2} /> {rc.label}
        </span>
      )}
      {list.map((b) => <Badge key={b.id} badge={b} accountTone={tone} size="compact" />)}
    </span>
  );
}
